
const SHOW_TRAJECTORY = 'MAP_SHOW_TRAJECTORY'
const HIDE_TRAJECTORY = 'MAP_HIDE_TRAJECTORY'


export function trajectory(state = {visible: false}, action) {
  switch (action.type) {
    case SHOW_TRAJECTORY:
    case HIDE_TRAJECTORY:
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export function showTrajectory(data) {
  return { type: SHOW_TRAJECTORY, payload: data }
}
export function hideTrajectory(data) {
  return { type: HIDE_TRAJECTORY, payload: data }
}

